import React, {useState} from 'react';
import {ArrowBack, ArrowForward, History} from "@material-ui/icons";
import axios from "axios";
import apiUrl from "../../../shared/config";
import { motion, AnimatePresence } from 'framer-motion';
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";

const EditHistoryPanel = ({ token, component_id, pattern_id, history_id, component_text_field, activeHistories, component, handleHistoryChange, handleActiveHistory, flag }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [history, setHistory] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const [showHistoryButtonWarning, setShowHistoryButtonWarning] = useState(false);
    const [showNoHistory, setShowNoHistory] = useState(false);
    const [showForwardButtonWarning, setShowForwardButtonWarning] = useState(false);
    const [showBackwardButtonWarning, setShowBackwardButtonWarning] = useState(false);
    const [button, setButton] = useState(() => {});


    const historyChangeWarning = (index, history, persisted_component_text_field, activateWarning, override) => {
        if (persisted_component_text_field !== component_text_field && !override) {
            activateWarning(() => {return () => historyChangeWarning(index, history, persisted_component_text_field, activateWarning, true)});
        } else {
            setCurrentIndex(index)
            if (!isOpen) {
                setIsOpen(true)
                setHistory(history)
                handleActiveHistory([...activeHistories, component_id])
            }
            handleHistoryChange(history[index])
        }
    }

    const toggleHistory = () => {
        if (isOpen) {
            setIsOpen(false)
            handleActiveHistory(activeHistories.filter((id) => {return +id !== component_id}))
        } else {
            // setIsOpen(true)
            axios.get(apiUrl +'Pattern/fetchHistory?pattern_id=' + pattern_id + "&component_id=" + component_id + "&flag=" + flag + "&token=" + token)
                .then(response => {
                    if (response.data.length < 1) {
                        setShowNoHistory(true)
                    } else {
                        console.log(response.data, history_id)
                        let curIndex = response.data.length - 1
                        let persistedComponentTextField = ''
                        response.data.forEach((data, index) => {
                            if (data.history_id === history_id) {
                                curIndex = index
                                persistedComponentTextField = textField(data)
                            }
                        })

                        historyChangeWarning(curIndex, response.data, persistedComponentTextField, (buttonFunction) => {
                            setShowHistoryButtonWarning(true)
                            setButton(buttonFunction)
                        }, false)
                        // setCurrentIndex(curIndex)
                        // setHistory(response.data)
                    }
                });
        }
    }

    const historyButton = () => {
        return <History
            onClick={() => toggleHistory()}
            style={{color: isOpen || isHovered ? "#558855" : "black"}}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        />
    }

    const warningPopover = (content, showState, setShowState) => {
        return <OverlayTrigger
            trigger="click"
            rootClose
            rootCloseEvent="click"
            placement='bottom'
            show={showState}
            onToggle={setShowState}
            overlay={<Popover id={"warning-popover"}>
                <Popover.Title>Browsing History Warning</Popover.Title>
            <Popover.Content>
                By browsing though this component's history, your current changes to the component's text field will be reverted. <br/>
                <div style={{display: "inline-flex", width: "100%", justifyContent: "flex-end"}}>
                <Button
                    onClick={() => {setShowState();}}
                    style={{margin: 5, backgroundColor: "#777777", borderColor: "#777777"}}
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => {setShowState(); button();}}
                    style={{margin: 5, backgroundColor: "#980000", borderColor: "#980000"}}
                >
                    Proceed
                </Button>
                </div>
            </Popover.Content>
        </Popover>}>
            {content}
        </OverlayTrigger>

    }

    const historyPopover = (content) => {
        return <OverlayTrigger
            trigger={["hover", "focus"]}
            rootClose
            rootCloseEvent="click"
            placement='bottom'
            show={showNoHistory}
            overlay={
            <Popover
                id={"history-popover"}
                onMouseEnter={() => setShowNoHistory(true)}
                onMouseLeave={() => setShowNoHistory(false)}
            >
                <Popover.Content>
                    The selected game doesn't have any persisted edit history.
                </Popover.Content>
            </Popover>}
        >
            <span onMouseLeave={() => setShowNoHistory(false)}>
                {content}
            </span>
        </OverlayTrigger>
        // return <OverlayTrigger
        //     trigger={["hover", "focus"]}
        //     rootClose
        //     rootCloseEvent="click"
        //     placement='bottom'
        //     show={showHistoryInfo}
        //     overlay={
        //     <Popover
        //         id={"history-popover"}
        //         onMouseEnter={() => setShowHistoryInfo(true)}
        //         onMouseLeave={() => setShowHistoryInfo(false)}
        //     >
        //         <Popover.Content>
        //             Edited made by {!component.user_id
        //             ? <>a Pattern Author</>
        //             : <b className={classes.Link} onClick={() => {openUserProfile(component.user_id); setShowHistoryInfo(false);}}>
        //                 {getDisplayName(component.display_name, component.first_name, component.last_name)}
        //             </b>} on {formatDate(component.edited_timestamp, "dateTime")}.
        //         </Popover.Content>
        //     </Popover>}
        // >
        //     <span onMouseEnter={() => setShowHistoryInfo(true)} onMouseLeave={() => setShowHistoryInfo(false)}>
        //         {content}
        //     </span>
        // </OverlayTrigger>
        // return content;

    }

    const textField = (component) => {
        switch (flag) {
            case "DESIGN_PROBLEM":
                return component.design_problem
            case "PATTERN_DESCRIPTION":
                return component.description
            case "PRIMARY_GAME":
                return component.example_description
            default:
                return ""
        }
    }

    return (pattern_id && component_id ?
        <div style={{display: "flex",  justifyContent: "flex-end", alignItems: "center", minWidth: 65, float: "right"}}>
            <AnimatePresence>{isOpen &&
                    <motion.div
                        animate={{opacity: 1, x: -45, y: -10}}
                        initial={{opacity: 0, x: 0, y: -10}}
                        exit={{opacity: 0, x: 0, y: -10}}
                        transition={{duration: 0.5, ease: "easeInOut"}}
                    >
                        {warningPopover(<ArrowBack
                            onClick={() => historyChangeWarning(Math.max(0, currentIndex-1), history, textField(history[currentIndex]),  (buttonFunction) => {
                                setShowBackwardButtonWarning(true)
                                setButton(buttonFunction)
                            }, false)}
                            style={currentIndex === 0 ? {color: 'lightgray', position: "absolute"} : {position: "absolute"}}
                        />, showBackwardButtonWarning,() => setShowBackwardButtonWarning(false))}
                    </motion.div>}
            </AnimatePresence>
            <AnimatePresence>
                <motion.div animate={{x: isOpen ? -20 : 0}}  transition={{duration: 0.5, ease: "easeInOut"}}>
                    {warningPopover(historyPopover(historyButton()), showHistoryButtonWarning, () => setShowHistoryButtonWarning(false))}
                </motion.div>
            </AnimatePresence>
            <AnimatePresence>{isOpen &&
                <motion.div
                    animate={{opacity: 1, x: -20, y: -10}}
                    initial={{opacity: 0, x: -20, y: -10}}
                    exit={{opacity: 0, x: -20, y: -10}}
                    transition={{duration: 0.5, ease: "easeInOut"}}
                >
                    {warningPopover(<ArrowForward
                        onClick={() => historyChangeWarning(Math.min(history.length - 1, currentIndex + 1), history, textField(history[currentIndex]),  (buttonFunction) => {
                            setShowForwardButtonWarning(true)
                            setButton(buttonFunction)
                        }, false)}
                        style={currentIndex === history.length - 1 ? {color: 'lightgray', position: "absolute"} : {position: "absolute"}}
                    />, showForwardButtonWarning, () => setShowForwardButtonWarning(false))}
                </motion.div>}
            </AnimatePresence>
        </div> : "")
};

export default EditHistoryPanel;
